import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// If you are using Tailwind, ensure your main CSS file is imported here. 
// It is usually called index.css
import './index.css'; 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);